import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

const SLIDER_ITEM_WIDTH = 330;

export const SliderWrapper = styled.section<{ quantity: number }>`
  position: relative;
  ${media.md`
    width: ${({ quantity }: any) => quantity * SLIDER_ITEM_WIDTH}px;
  `};

  max-width: 100%;
  margin: 0 auto;

  .slick-initialized .slick-track {
    display: flex;

    .slick-slide {
      display: flex;
      height: inherit !important;
      align-items: stretch;
      justify-content: stretch;
    }
  }
`;

export const EntityItemsRow = styled.div`
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 10px -20px;

  ${media.md`
    margin: 10px -10px;
  `}
`;

export const EntityItem = styled.div`
  padding: 0 10px;
  min-width: 345px;

  & > a {
    display: block;
  }

  ${media.md`
    max-width: 345px;
  `}
`;

export const Background = styled.div`
  width: 325px;
  height: 217px;
  background-color: ${({ theme }) => theme.customColors.tertiary};
`;

export const ItemDetails = styled.div`
  padding: 10px 0;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

export const ItemName = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: 18px;
`;

export const PriceWrapper = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;
